module.exports = __webpack_public_path__ + "static/media/service-icon-02.c09fd639.gif";